import { InMyPocket } from '@core/models/interfaces/storage-data/in-my-pocket';
import { createActionGroup, props } from '@ngrx/store';
import { DateTime } from 'luxon';

export const PocketActions = createActionGroup({
  source: 'Pocket',
  events: {
    'Load Pocket Success': props<{ pocket: InMyPocket }>(),

    'Set Pocket Selected Date': props<{ selectedDate: DateTime }>(),
  },
});
